<section id="faq" class="faq-section faq-section--pad mx-auto w-full py-12" aria-label="Frequently asked questions">
  <div class="faq-inner flex w-full flex-col gap-6">

    <!-- Left: intro summary panel -->
    <div class="faq-summary flex flex-col gap-6 rounded-2xl border p-6">
      <span class="faq-badge inline-flex w-fit items-center gap-2 rounded-full px-3.5 py-2 text-sm font-semibold">
        <img [src]="badgeIconPath" alt="" aria-hidden="true" class="h-4 w-4 shrink-0 object-contain" />
        Frequently asked questions
      </span>

      <h2 class="faq-title font-bold leading-tight">
        Everything a user needs to understand before exploring the platform
      </h2>

      <ul class="faq-benefits m-0 flex list-none flex-col gap-3 p-0">
        @for (b of benefits; track b.label) {
          <li class="faq-benefit-card flex items-center gap-3 rounded-2xl border px-4 py-3.5">
            <img
              [src]="b.iconPath"
              alt=""
              aria-hidden="true"
              class="faq-benefit-icon h-5 w-5 shrink-0 object-contain"
            />
            <p class="faq-benefit-text m-0 leading-snug">{{ b.label }}</p>
          </li>
        }
      </ul>
    </div>

    <!-- Right: accordion -->
    <div class="faq-accordion flex min-w-0 flex-1 flex-col gap-4" role="region" aria-label="Frequently asked questions">
      @for (faq of faqs; track faq.question; let i = $index) {
        <div class="faq-item overflow-hidden rounded-2xl border">
          <button
            type="button"
            class="faq-item-header flex w-full items-start justify-between gap-4 p-5 text-left"
            [attr.aria-expanded]="isOpen(i)"
            [attr.aria-controls]="'faq-panel-' + i"
            [id]="'faq-trigger-' + i"
            (click)="toggle(i)"
          >
            <span class="faq-item-question font-bold">{{ faq.question }}</span>
            <span class="faq-toggle-icon-wrap shrink-0" [class.faq-toggle-icon-wrap--open]="isOpen(i)" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="faq-toggle-icon-bar-h" d="M3.75 9H14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path class="faq-toggle-icon-bar-v" d="M9 3.75V14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
          </button>
          <div
            class="faq-item-panel-outer"
            [class.faq-item-panel-outer--open]="isOpen(i)"
            role="region"
            [attr.id]="'faq-panel-' + i"
            [attr.aria-labelledby]="'faq-trigger-' + i"
            [attr.aria-hidden]="isOpen(i) ? null : 'true'"
          >
            <div class="faq-item-panel-inner">
              <p class="faq-item-answer m-0 px-5 pb-5 pt-0 leading-relaxed">{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      }
    </div>

  </div>
</section>
